import { WorkoutMode } from '@kinomap-dev/ng-ui-lib/core';

export const SPORT_TYPES = ['cycling', 'running', 'rowing'] as const;
export type SportType = (typeof SPORT_TYPES)[number];

/**
 * Les workouts acceptent un sport de plus que les autres contenus : l'elliptique,
 * qui n'a pas de video associee. `SportType` reste le type des contenus filmes.
 */
export const WORKOUT_SPORT_TYPES = [...SPORT_TYPES, 'elliptical'] as const;
export type WorkoutSportType = (typeof WORKOUT_SPORT_TYPES)[number];

/** Modes d'entrainement disponibles pour un sport (workout comme coaching). */
export function getWorkoutModes(sport: WorkoutSportType | undefined): WorkoutMode[] | undefined {
  switch (sport) {
    case 'cycling':
      return ['ftp', 'watts', 'res', 'inc'];
    case 'running':
      return ['inc', 'spd', 'incSpd'];
    case 'rowing':
    case 'elliptical':
      return ['res'];
    default:
      return undefined;
  }
}
